// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TZxA","questions":"styles_questions__1HT0C","footer":"styles_footer__T24IW"};